import {
  MFAContainer
} from "../styled";
import React, {useState} from "react";
import {setNewToken, validateMfa} from "../../actions/authActions";
import {BackupCodeButton} from "./backupCodeButton";
import {MFA_TYPE, MINIMUM_ATTEMPTS, LEFT_ATTEMPTS_FOR_WARN, MAX_CODE_LENGTH} from "../constants";
import {Button, Checkbox, Form, Message} from "semantic-ui-react";
import {CustomDivider} from "../../components/custom-common";

const hasIncompleteCode = (value) => value?.length > 0 && value.length < MAX_CODE_LENGTH;

export const AuthAppToVerified = ({
    userName,
    mfaToken,
    redirectPath,
    history,
    dispatch,
    redirectToLogin,
    rememberDeviceDays,
    handleUseMethod
  }) => {

  const [mfaCode, setMfaCode] = useState("");
  const [validationErrors, setValidationErrors] = useState(false);
  const [validateMfaCodeError, setValidateMfaCodeError] = useState("");
  const [isMfaProcessing, setIsMfaProcessing] = useState(false);
  const [remainingTotpAttempts, setRemainingTotpAttempts] = useState(null);
  const [disableBtn, setDisableBtn] = useState(true);
  const [remember, setRemember] = useState(false);
  //Input Backup code handler and validation
  const codeHandler = (e) => {
    setValidateMfaCodeError("");
    setDisableBtn(!(e.currentTarget.value.length > 0))

    let sanitizedValue = e.currentTarget.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*)\./g, "$1");
    if (sanitizedValue.length > MAX_CODE_LENGTH || isNaN(sanitizedValue)) return;

    setValidationErrors(hasIncompleteCode(sanitizedValue));
    setMfaCode(sanitizedValue);
  };


  //Submit code to mfa/login
  const submitCode = async () => {
    setValidateMfaCodeError("");
    setIsMfaProcessing(true);
    if (mfaCode.length <= 5 || isNaN(mfaCode) || mfaCode === "") {
      setValidationErrors(true);
      setIsMfaProcessing(false);
      return false;
    }
    try {
      const response = await validateMfa(userName, mfaCode, mfaToken, remember, MFA_TYPE.TOTP)
      dispatch(setNewToken(response.data));
      history.push({ pathname: redirectPath });
    } catch (error) {
      const { errorMessage, remainingTotpCodeAttempts, remainingBackupCodeAttempts } =
        error.response.data;
      setIsMfaProcessing(false);
      setValidateMfaCodeError(errorMessage);
      if(remainingTotpCodeAttempts === MINIMUM_ATTEMPTS || remainingBackupCodeAttempts === MINIMUM_ATTEMPTS){
        redirectToLogin(true);
      }
      setRemainingTotpAttempts(remainingTotpCodeAttempts);
    }
  };

  return (
    <>
      <p className={"small"}>
        Enter the 6-digit authentication code from your authenticator app to continue—
      </p>

      {remainingTotpAttempts && (remainingTotpAttempts <= LEFT_ATTEMPTS_FOR_WARN) && (
          <Message negative className={"invalidAttempt smaller"}>
            <b>
              {remainingTotpAttempts}{" "}
              invalid attempt(s) remaining!
            </b>{" "}
            After your <br/>account will be locked for security purposes.{" "}
          </Message>
        )}

      <Form>
        <Form.Field>
          <MFAContainer className="changeMethodField">
            <Form.Input fluid className={'noVerticalMargin'}
              label={"6-digit authentication code"}
              type="text"
              name="mfaCode"
              id="mfaCode"
              onChange={(e) => codeHandler(e)}
              value={mfaCode}
              maxLength={MAX_CODE_LENGTH}
              required
              error={(validationErrors || !!validateMfaCodeError)}
              disabled={isMfaProcessing}
            />
            {validationErrors && <span className={'warningRedText smaller'}>Enter a 6-digit authentication code</span>}
            {validateMfaCodeError && (
              <span className={'warningRedText smaller'}>
                Invalid code, please try again.
              </span>
            )}
          </MFAContainer>
          <MFAContainer className="changeMethodField">
            <Checkbox
              label={`Remember me on this device for ${rememberDeviceDays} days`}
              name={"mfaRemember"}
              id={"mfaRemember"}
              onChange={() => setRemember(!remember)}
            />

          </MFAContainer>
          <Button primary fluid
            loading={isMfaProcessing}
            disabled={isMfaProcessing || disableBtn}
            onClick={submitCode}
          >
            Submit
          </Button>
        </Form.Field>
      </Form>
      <CustomDivider small hidden/>

      <BackupCodeButton handleUseMethod={() => handleUseMethod(MFA_TYPE.BACKUP_CODES)} />
    </>
  )
}
